import { Location } from "../interfaces";
import { Company } from "../interfaces/Company";

export type CompanyWithLocation = Company & Location;
